// Serbian labels for the backend's English enum tokens (src/models/personal-survey.model.ts
// in api-zeleni-sokovi-nemet). Field configs below drive both read-mode display and edit-mode
// inputs for the personal survey (Deo A + Deo B, Modules 1-8) - see SurveySection.js.

export const GENDER_LABELS = {
  female: 'Žensko',
  male: 'Muško',
  other: 'Drugo',
};

export const APP_REASON_LABELS = {
  self_knowledge: 'Bolje upoznavanje sebe',
  health_tracking: 'Praćenje zdravlja i navika',
  personalized_recs: 'Personalizovane preporuke',
  appearance_fitness: 'Poboljšanje izgleda i forme',
  life_organization: 'Bolja organizacija života',
  relationships: 'Bolji odnosi sa ljudima',
  prevention: 'Prevencija i zdraviji životni stil',
};

export const FITNESS_GOAL_LABELS = {
  weight_loss: 'Mršavljenje',
  muscle_gain: 'Dobijanje mišićne mase',
  maintain_form: 'Održavanje trenutne forme',
  better_condition: 'Bolja kondicija',
  better_health: 'Bolje zdravlje',
  body_shaping: 'Oblikovanje tela',
};

export const WORK_STATUS_LABELS = {
  employed: 'Zaposlen/a',
  entrepreneur: 'Preduzetnik/ca',
  student: 'Student/kinja',
  unemployed: 'Nezaposlen/a',
  retired: 'Penzioner/ka',
  homemaker: 'Rad u domaćinstvu',
};

export const DIET_TYPE_LABELS = {
  mixed: 'Mešovita ishrana',
  vegetarian: 'Vegetarijanska ishrana',
  vegan: 'Veganska ishrana',
  low_carb_keto: 'Low-carb/keto',
  gluten_free: 'Bez glutena',
  lactose_free: 'Bez laktoze',
  medical: 'Poseban medicinski režim ishrane',
  other: 'Drugo',
  none: 'Ne pridržavam se nijednog posebnog načina ishrane',
};

export const ACTIVITY_FREQUENCY_LABELS = {
  never: 'Nikada',
  once_week: '1 put nedeljno',
  '2_3_week': '2-3 puta nedeljno',
  '4_5_week': '4-5 puta nedeljno',
  daily: 'Svaki dan',
};

export const SLEEP_HOURS_LABELS = {
  lt_5: 'Manje od 5 sati',
  '5_6': '5-6 sati',
  '6_7': '6-7 sati',
  '7_8': '7-8 sati',
  gt_8: 'Više od 8 sati',
};

export const INTEREST_TOPIC_LABELS = {
  health: 'Zdravlje',
  fitness: 'Fitnes',
  nutrition: 'Ishrana',
  psychology: 'Psihologija',
  career: 'Karijera',
  travel: 'Putovanja',
  fashion: 'Moda',
  technology: 'Tehnologija',
  finance: 'Finansije',
  family: 'Porodica',
  relationships: 'Ljubavni odnosi',
  spirituality: 'Duhovnost',
};

export const COMMUNICATION_STYLE_LABELS = {
  short_direct: 'Kratko i direktno',
  detailed_educational: 'Detaljno i edukativno',
  motivational: 'Motivaciono',
  strict_disciplined: 'Strogo i disciplinovano',
  friendly_relaxed: 'Prijateljski i opušteno',
};

export const WEIGHT_CHANGE_LABELS = {
  unchanged: 'Nije se promenila',
  increased: 'Povećala se',
  decreased: 'Smanjila se',
};

export const LIVING_SITUATION_LABELS = {
  alone: 'Živim sam/a',
  with_others: 'Živim sa jednom ili više osoba',
};

export const LIVING_WITH_LABELS = {
  partner: 'Partner/partnerka',
  children: 'Dete/deca',
  parents: 'Roditelji',
  siblings: 'Braća/sestre',
  other_family: 'Drugi članovi porodice',
  roommates: 'Cimeri',
  other: 'Druga osoba',
};

export const CAREGIVING_INVOLVEMENT_LABELS = {
  none: 'Nemam takve obaveze',
  occasional: 'Povremeno pružam podršku ili brinem o nekome',
  regular: 'Redovno pružam podršku ili brinem o nekome',
  daily: 'Svakodnevno imam značajne obaveze vezane za brigu ili podršku drugima',
};

export const CAREGIVING_FOR_LABELS = {
  children: 'Deci',
  elderly_family: 'Starijem članu porodice',
  family_health_needs: 'Članu porodice sa zdravstvenim ili funkcionalnim poteškoćama',
  partner: 'Partneru/partnerki',
  other: 'Drugoj osobi',
};

export const CHILD_AGE_GROUP_LABELS = {
  '0_3': '0-3',
  '4_6': '4-6',
  '7_12': '7-12',
  '13_17': '13-17',
  '18_plus': '18+',
};

export const LIVING_STABILITY_LABELS = {
  stable_organized: 'Stabilno i organizovano, sa dovoljno prostora za svakodnevnu rutinu',
  mostly_stable: 'Uglavnom stabilno, uz povremena prilagođavanja',
  routine_adjusts_to_others: 'Rutina se često usklađuje sa drugim osobama ili obavezama',
  variable_multiple_locations: 'Promenljivo, jer boravim ili funkcionišem na više lokacija',
  currently_challenging: 'Trenutno mi je izazovno da održim stalnu rutinu',
};

export const EDUCATION_LEVEL_LABELS = {
  primary_school: 'Osnovna škola',
  high_school: 'Srednja škola',
  college: 'Viša škola',
  university: 'Fakultet',
  master: 'Master',
  doctorate: 'Doktorat',
};

export const WORK_FIELD_LABELS = {
  it: 'IT',
  healthcare: 'Zdravstvo',
  education: 'Obrazovanje',
  finance: 'Finansije',
  law: 'Pravo',
  marketing: 'Marketing',
  sales: 'Prodaja',
  arts: 'Umetnost',
  hospitality: 'Ugostiteljstvo',
  manufacturing: 'Proizvodnja',
  administration: 'Administracija',
  other: 'Drugo',
};

export const WORK_MODE_LABELS = {
  from_home: 'Od kuće',
  office: 'Iz kancelarije/ustanove',
  hybrid: 'Hibridno',
  field: 'Na terenu',
  shifts: 'U smenama',
  none: 'Trenutno nemam radne ili studentske obaveze',
};

export const SITTING_HOURS_LABELS = {
  lt_2: 'Manje od 2 sata',
  '2_4': '2-4 sata',
  '4_6': '4-6 sati',
  '6_8': '6-8 sati',
  gt_8: 'Više od 8 sati',
};

export const MEALS_PER_DAY_LABELS = {
  1: '1 obrok',
  2: '2 obroka',
  3: '3 obroka',
  4: '4 obroka',
  '5_or_more': '5 ili više obroka',
  irregular: 'Neredovan raspored obroka',
};

export const FRUIT_VEG_FREQUENCY_LABELS = {
  daily: 'Svaki dan',
  '4_6_week': '4-6 puta nedeljno',
  '2_3_week': '2-3 puta nedeljno',
  once_week: 'Jednom nedeljno',
  less_than_week: 'Ređe od jednom nedeljno',
};

export const ACTIVITY_TYPE_LABELS = {
  walking: 'Šetnja',
  gym: 'Teretana',
  running: 'Trčanje',
  cycling: 'Bicikl',
  sport: 'Sport',
  yoga_pilates: 'Joga/pilates',
  other: 'Drugo',
};

export const TOBACCO_USE_LABELS = {
  none: 'Ne koristim',
  occasional: 'Koristim povremeno',
  daily: 'Koristim svakodnevno',
  former: 'Ranije sam koristio/la',
};

export const SECONDHAND_SMOKE_LABELS = {
  no: 'Ne',
  home: 'Da - kod kuće',
  work: 'Da - na poslu',
  social: 'Da - u društvu',
  multiple_places: 'Da - na više mesta',
};

export const ALCOHOL_FREQUENCY_LABELS = {
  never: 'Nikada',
  rarely: 'Retko',
  '1_2_month': '1-2 puta mesečno',
  '1_2_week': '1-2 puta nedeljno',
  '3plus_week': '3 ili više puta nedeljno',
  daily: 'Svakodnevno',
};

export const CAFFEINE_INTAKE_LABELS = {
  none: 'Ne unosim kofein',
  1: '1 kafa ili kofeinski napitak dnevno',
  2: '2 kafe ili napitka dnevno',
  3: '3 kafe ili napitka dnevno',
  '4_or_more': '4 ili više kafa ili napitaka dnevno',
};

export const CONDITION_CATEGORY_LABELS = {
  autoimmune: 'Autoimuna bolest',
  diabetes: 'Dijabetes',
  hypertension: 'Povišen krvni pritisak',
  heart_disease: 'Bolest srca',
  respiratory: 'Respiratorna',
  neurological: 'Neurološka',
  hormonal: 'Hormonska',
  gastrointestinal: 'Gastrointestinalna',
  kidney_liver: 'Bubrega/jetre',
  psychiatric: 'Psihijatrijska',
  dermatological: 'Dermatološka',
  other: 'Drugo',
};

export const CONDITION_STATUS_LABELS = {
  active: 'Aktivno stanje',
  stable_controlled: 'Stabilno pod kontrolom',
  therapy_in_progress: 'Terapija u toku',
  remission: 'U remisiji',
  previously_diagnosed_asymptomatic: 'Ranije dijagnostikovano bez simptoma',
  intermittent_symptoms: 'Povremeno se vraćaju simptomi',
};

export const ALLERGY_TYPE_LABELS = {
  medication: 'Lekovi',
  food: 'Hrana',
  pollen: 'Polen',
  dust: 'Prašina',
  animals: 'Životinje',
  latex: 'Lateks',
  other: 'Drugo',
};

export const FAMILY_HISTORY_TYPE_LABELS = {
  cancer: 'Maligne bolesti/rak',
  autoimmune: 'Autoimune bolesti',
  cardiovascular: 'Bolesti srca i krvnih sudova',
  diabetes: 'Dijabetes',
  neurological: 'Neurološke bolesti',
  psychiatric: 'Psihijatrijska oboljenja',
  other: 'Drugo',
};

export const SOCIAL_STYLE_LABELS = {
  introvert: 'Više sam introvertna osoba',
  extrovert: 'Više sam ekstrovertna osoba',
  both: 'Kombinacija oba',
  depends_on_situation: 'Zavisi od situacije',
};

export const IMPROVEMENT_AREA_LABELS = {
  health: 'Zdravlje',
  appearance: 'Izgled',
  fitness: 'Kondicija',
  sleep: 'San',
  nutrition: 'Ishrana',
  stress: 'Stres',
  confidence: 'Samopouzdanje',
  love_life: 'Ljubavni život',
  social_life: 'Društveni život',
  career: 'Karijera',
  finance: 'Finansije',
  habits: 'Navike',
};

export const YES_NO_LABELS = { true: 'Da', false: 'Ne' };

export const optionsFromLabels = (labelMap) =>
  Object.entries(labelMap).map(([value, label]) => ({ value, label }));

export const labelFor = (labelMap, value) => {
  if (value == null || value === '') return '-';
  return labelMap?.[value] ?? String(value);
};

export const PART_A_FIELDS = [
  { key: 'gender', label: 'Pol', type: 'select', options: GENDER_LABELS, required: true },
  { key: 'birthYear', label: 'Godina rođenja', type: 'number', min: 1900, max: new Date().getFullYear(), required: true },
  { key: 'appReason', label: 'Glavni razlog korišćenja aplikacije', type: 'select', options: APP_REASON_LABELS, required: true },
  { key: 'fitnessGoal', label: 'Glavni cilj vezan za telo/kondiciju', type: 'select', options: FITNESS_GOAL_LABELS, required: true },
  { key: 'workStatus', label: 'Radni status', type: 'select', options: WORK_STATUS_LABELS, required: true },
  { key: 'dietType', label: 'Tip ishrane', type: 'select', options: DIET_TYPE_LABELS, required: true },
  { key: 'dietTypeOther', label: 'Tip ishrane (drugo)', type: 'text', visibleIf: (v) => v.dietType === 'other', groupWith: 'dietType' },
  { key: 'activityFrequency', label: 'Učestalost fizičke aktivnosti', type: 'select', options: ACTIVITY_FREQUENCY_LABELS, required: true },
  { key: 'sleepHours', label: 'Sati sna', type: 'select', options: SLEEP_HOURS_LABELS, required: true },
  { key: 'stressLevel', label: 'Nivo stresa', type: 'rating', min: 1, max: 5, required: true },
  { key: 'hasChronicCondition', label: 'Hronično zdravstveno stanje', type: 'boolean', required: true },
  { key: 'interests', label: 'Interesovanja (max 5)', type: 'multiselect', options: INTEREST_TOPIC_LABELS, maxSelect: 5, required: true },
  { key: 'communicationStyle', label: 'Stil komunikacije', type: 'select', options: COMMUNICATION_STYLE_LABELS, required: true },
];

export const MODULE_1_FIELDS = [
  { key: 'heightCm', label: 'Visina (cm)', type: 'number', min: 50, max: 260, required: true },
  { key: 'weightKg', label: 'Težina (kg)', type: 'number', min: 20, max: 400, required: true },
  { key: 'weightChange', label: 'Promena težine u poslednjih 6 meseci', type: 'select', options: WEIGHT_CHANGE_LABELS, required: true },
  { key: 'weightChangeDeltaKg', label: 'Promena težine (kg)', type: 'number', min: 0, visibleIf: (v) => v.weightChange && v.weightChange !== 'unchanged', groupWith: 'weightChange' },
  { key: 'fitnessSelfRating', label: 'Samoocena fizičke forme', type: 'rating', min: 1, max: 5, required: true },
];

export const MODULE_2_FIELDS = [
  { key: 'livingSituation', label: 'Životna situacija', type: 'select', options: LIVING_SITUATION_LABELS, required: true },
  { key: 'livingWith', label: 'Živi sa', type: 'multiselect', options: LIVING_WITH_LABELS, visibleIf: (v) => v.livingSituation === 'with_others', groupWith: 'livingSituation' },
  { key: 'livingWithOther', label: 'Živi sa (drugo)', type: 'text', visibleIf: (v) => Array.isArray(v.livingWith) && v.livingWith.includes('other'), groupWith: 'livingWith' },
  { key: 'caregivingInvolvement', label: 'Angažovanje u brizi o drugima', type: 'select', options: CAREGIVING_INVOLVEMENT_LABELS, required: true },
  { key: 'caregivingFor', label: 'Brine o', type: 'multiselect', options: CAREGIVING_FOR_LABELS, visibleIf: (v) => v.caregivingInvolvement === 'regular' || v.caregivingInvolvement === 'daily', groupWith: 'caregivingInvolvement' },
  { key: 'caregivingForOther', label: 'Brine o (drugo)', type: 'text', visibleIf: (v) => Array.isArray(v.caregivingFor) && v.caregivingFor.includes('other'), groupWith: 'caregivingFor' },
  { key: 'householdSize', label: 'Broj članova domaćinstva', type: 'number', min: 1, max: 15, required: true },
  { key: 'hasChildren', label: 'Ima decu', type: 'boolean', required: true },
  { key: 'childrenCount', label: 'Broj dece', type: 'number', min: 1, visibleIf: (v) => v.hasChildren === true, groupWith: 'hasChildren' },
  { key: 'childrenAgeGroups', label: 'Uzrasne grupe dece', type: 'multiselect', options: CHILD_AGE_GROUP_LABELS, visibleIf: (v) => v.hasChildren === true, groupWith: 'hasChildren' },
  { key: 'livingStability', label: 'Stabilnost životnog okruženja', type: 'select', options: LIVING_STABILITY_LABELS, required: true },
];

export const MODULE_3_FIELDS = [
  { key: 'educationLevel', label: 'Nivo obrazovanja', type: 'select', options: EDUCATION_LEVEL_LABELS, required: true },
  { key: 'workField', label: 'Oblast rada/obrazovanja', type: 'select', options: WORK_FIELD_LABELS, required: true },
  { key: 'workFieldOther', label: 'Oblast rada (drugo)', type: 'text', visibleIf: (v) => v.workField === 'other', groupWith: 'workField' },
  { key: 'workMode', label: 'Način obavljanja posla', type: 'select', options: WORK_MODE_LABELS, required: true },
  { key: 'dailySittingHours', label: 'Sati sedenja dnevno', type: 'select', options: SITTING_HOURS_LABELS, required: true },
];

export const MODULE_4_FIELDS = [
  { key: 'mealsPerDay', label: 'Broj obroka dnevno', type: 'select', options: MEALS_PER_DAY_LABELS, required: true },
  { key: 'fruitVegFrequency', label: 'Učestalost konzumiranja voća/povrća', type: 'select', options: FRUIT_VEG_FREQUENCY_LABELS, required: true },
  { key: 'activityType', label: 'Tip fizičke aktivnosti', type: 'select', options: ACTIVITY_TYPE_LABELS },
  { key: 'activityTypeOther', label: 'Tip fizičke aktivnosti (drugo)', type: 'text', visibleIf: (v) => v.activityType === 'other', groupWith: 'activityType' },
];

export const MODULE_5_FIELDS = [
  { key: 'tobaccoUse', label: 'Korišćenje duvana', type: 'select', options: TOBACCO_USE_LABELS, required: true },
  { key: 'secondhandSmoke', label: 'Izloženost pasivnom pušenju', type: 'select', options: SECONDHAND_SMOKE_LABELS, required: true },
  { key: 'alcoholFrequency', label: 'Učestalost konzumiranja alkohola', type: 'select', options: ALCOHOL_FREQUENCY_LABELS, required: true },
  { key: 'caffeineIntake', label: 'Unos kofeina', type: 'select', options: CAFFEINE_INTAKE_LABELS, required: true },
];

export const MODULE_6_FIELDS = [
  {
    key: 'conditions',
    label: 'Zdravstvena stanja',
    type: 'repeatable',
    itemFields: [
      { key: 'category', label: 'Kategorija', type: 'select', options: CONDITION_CATEGORY_LABELS, required: true },
      { key: 'name', label: 'Naziv', type: 'text', required: true },
      { key: 'status', label: 'Status', type: 'select', options: CONDITION_STATUS_LABELS, required: true },
    ],
  },
  { key: 'onTherapy', label: 'Na terapiji', type: 'boolean', required: true },
  { key: 'therapyDetails', label: 'Detalji terapije', type: 'text', visibleIf: (v) => v.onTherapy === true, groupWith: 'onTherapy' },
  { key: 'hasAllergies', label: 'Ima alergije', type: 'boolean', required: true },
  { key: 'allergyTypes', label: 'Tipovi alergija', type: 'multiselect', options: ALLERGY_TYPE_LABELS, visibleIf: (v) => v.hasAllergies === true, groupWith: 'hasAllergies' },
  { key: 'allergyOther', label: 'Alergije (drugo)', type: 'text', visibleIf: (v) => Array.isArray(v.allergyTypes) && v.allergyTypes.includes('other'), groupWith: 'allergyTypes' },
  { key: 'familyHistory', label: 'Porodična istorija bolesti', type: 'boolean', required: true },
  { key: 'familyHistoryTypes', label: 'Tipovi porodične istorije', type: 'multiselect', options: FAMILY_HISTORY_TYPE_LABELS, visibleIf: (v) => v.familyHistory === true, groupWith: 'familyHistory' },
  { key: 'familyHistoryOther', label: 'Porodična istorija (drugo)', type: 'text', visibleIf: (v) => Array.isArray(v.familyHistoryTypes) && v.familyHistoryTypes.includes('other'), groupWith: 'familyHistoryTypes' },
];

export const MODULE_7_FIELDS = [
  { key: 'socialStyle', label: 'Društveni stil', type: 'select', options: SOCIAL_STYLE_LABELS, required: true },
  { key: 'improvementAreas', label: 'Oblasti za poboljšanje (max 3)', type: 'multiselect', options: IMPROVEMENT_AREA_LABELS, maxSelect: 3, required: true },
];

export const MODULE_8_FIELDS = [
  { key: 'usedProductBefore', label: 'Koristio/la proizvod ranije', type: 'boolean', required: true },
  { key: 'productName', label: 'Naziv proizvoda', type: 'text', visibleIf: (v) => v.usedProductBefore === true, groupWith: 'usedProductBefore' },
];

export const SURVEY_SECTIONS = [
  { key: 'partA', title: 'Osnovna anketa', fieldConfig: PART_A_FIELDS },
  { key: 'module1', title: 'Telo i fizička forma', fieldConfig: MODULE_1_FIELDS },
  { key: 'module2', title: 'Domaćinstvo i životne okolnosti', fieldConfig: MODULE_2_FIELDS },
  { key: 'module3', title: 'Obrazovanje, posao i dnevni ritam', fieldConfig: MODULE_3_FIELDS },
  { key: 'module4', title: 'Ishrana i fizička aktivnost (detaljnije)', fieldConfig: MODULE_4_FIELDS },
  { key: 'module5', title: 'Navike i faktori rizika', fieldConfig: MODULE_5_FIELDS },
  { key: 'module6', title: 'Zdravstveno stanje, terapije i alergije', fieldConfig: MODULE_6_FIELDS },
  { key: 'module7', title: 'Ličnost i interesovanja', fieldConfig: MODULE_7_FIELDS },
  { key: 'module8', title: 'Iskustvo sa našim proizvodima', fieldConfig: MODULE_8_FIELDS },
];
